/* 
 * DesertLandscaping.Controller 
 */
import { App } from './desertland.app';
import { Utils } from './cals.utils';
import { ROUTES } from './desertland.router';
import { AddThis } from './cals.addthis';

/* tslint:ignore member-ordering */
declare var log, info, warn, groupCollapsed, groupEnd, ga;

const getPageTitle = (route: string): string => {
  return `${Utils.strDashedToCaps(route)} :: Desert Landscaping`;
};

export class Controller {
  
  // public gaTitle: string = "Desert Landscaping"; // moved to App
  // public shareUrl: string = ""; // moved to App
  
  private mainContainer: string = "#tmpl_main_content";

  

  public home(params) {
    let route = ROUTES.HOME;
    info(route, params);
    //App.currentPage = "index"; // for menu item id ".topnav-item-"+App.currentPage
    App.shareUrl = "";
    let shareArgs = params ? { loc: params } : null;
    this.onRoute(route, "/", getPageTitle('home'), shareArgs);
    App.content.Home.init();
  }

  public tips(suffix) {
    let route = ROUTES.TIPS;
    info(route, suffix);
    App.shareUrl = route + "/";// + "/?share=" + route + qs;
    // let qs = suffix ? "&loc=" + suffix : "";
    let shareArgs = suffix ? { loc: suffix } : null;

    if (App.currentPage === route) {
      info(`we're already on the ${ROUTES.TIPS} page - update`);
      this.updateShareVars(getPageTitle(route), shareArgs);
      App.content.Tips.onRoute(suffix);
    } else {
      this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
      App.content.Tips.init(suffix);
    }
  }

  public ideas(params) {
    let route = ROUTES.IDEAS;
    info(route, params);
    let shareArgs = params ? { loc: params } : null;
    App.shareUrl = route + "/";// + qs;
    this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
    App.content.Ideas.init(params);
  }

  public trivia(params) {
    let route = ROUTES.TRIVIA;
    info(route, params);
    let shareArgs = params ? { loc: params } : null;
    // let qs = params ? '/?share=' + route + "&loc=" + params : "";
    if (App.config.features.enableTrivia) {
      App.shareUrl = route + "/";//qs;
      this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
      App.content.Trivia.init();
    } else {
      console.log("Trivia Feature is no longer available...");
      this.home(params);
    }
  }

  public resources(params) {
    let route = ROUTES.RESOURCES;
    info(route, params);
    let shareArgs = params ? { loc: params } : null;
    // let qs = params ? "&loc=" + params : "";
    App.shareUrl = route + "/";//+ '/?share=' + route + qs;
    this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
    App.content.Resources.init(params);
  }

  public about(params) {
    let route = ROUTES.ABOUT;
    info(route, params);
    let shareArgs = params ? { loc: params } : null;
    //    let qs = params ? "&loc=" + params : "";
    App.shareUrl = route + "/";//+ '/?share=' + route + qs;
    this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
    App.content.About.init(params);
  }

  public acknowledge(params) {
    let route = ROUTES.ACKNOWLEDGE;
    info(route, params);
    let shareArgs = params ? { loc: params } : null;
    //    let qs = params ? "&loc=" + params : "";
    App.shareUrl = route + "/";//+ '/?share=' + route + qs;
    this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
    App.content.Acknowledge.init(params);
  }
  public bibliography(params) {
    let route = ROUTES.BIBLIOGRAPHY;
    info(route, params);
    let shareArgs = params ? { loc: params } : null;
    //    let qs = params ? "&loc=" + params : "";
    App.shareUrl = route + "/";//+ '/?share=' + route + qs;
    this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
    App.content.Bibliography.init(params);
  }
  public history(params) {
    let route = ROUTES.HISTORY;
    info(route, params);
    let shareArgs = params ? { loc: params } : null;
    //    let qs = params ? "&loc=" + params : "";
    App.shareUrl = route + "/";//+ '/?share=' + route + qs;
    this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
    App.content.History.init(params);
  }

  public learnmore(params) {
    let route = ROUTES.LEARN;
    info(route, params);
    let shareArgs = params ? { loc: params } : null;
    //    let qs = params ? "&loc=" + params : "";
    App.shareUrl = route + "/";//+ '/?share=' + route + qs;
    this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
    App.content.Learnmore.init(params);
  }

  public contact(params) {
    let route = ROUTES.CONTACT;
    info(route, params);
    let shareArgs = params ? { loc: params } : null;
    // let qs = params ? "?loc=" + params : "";
    App.shareUrl = route + "/";//+ '/' + qs;
    this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
    App.content.Contact.init(params);
  }

  public plant(id, name, suffix) {
    let route = ROUTES.PLANT;
    info(route, id, name, suffix);
    let shareArgs = null;
    if (id) {
      shareArgs = {};
      shareArgs.id = id;
    }
    if (name) {
      shareArgs = shareArgs || {};
      shareArgs.name = name;
    }
    if (suffix) {
      shareArgs = shareArgs || {};
      shareArgs.loc = suffix;
    }
    //    let qs = suffix ? "&loc=" + suffix : "";
    // App.shareUrl = "plants/";// + '/?share=' + route + 'name=' + name + "&id=" + id + qs;
    App.shareUrl = route + "/";// TODO: verify this change (2018)
    this.onRoute(route, "/" + route + "/" + id + "/" + name, getPageTitle(route), shareArgs);
    App.content.Plant.init({ id, name, suffix });
  }

  public plants(suffix) {
    let route = ROUTES.PLANTS;
    info(route, suffix);
    let shareArgs = suffix ? { loc: suffix } : null;
    // let qs = suffix ? "&loc=" + suffix : "";
    App.shareUrl = route + "/";// + '/?share=' + route + qs;
    this.onRoute(route, "/" + route, getPageTitle(route), shareArgs);
    //this.resetMainContent(App.Plants.init, {suffix:suffix});
    App.plants.init({ suffix });
  }

  public dynamic(suffix) {
    let route = ROUTES.HOME;
    info("dynamic", suffix);
    let shareArgs = suffix ? { loc: suffix } : null;
    //    let qs = suffix ? "&loc=" + suffix : "";
    App.shareUrl = route + "/";// + '/?share=' + route + qs;
    this.onRoute(route, "/" + route, getPageTitle(route) + "[dynamic]", shareArgs);
  }



  public onRoute(page, gaPage, gaTitle, args) {
    log("onRoute:", page);
    App.currentPage = page;

    if (!Utils.isLocalhost()) {
      log("ga send page: %s && title: %s", gaPage, gaTitle);
      ga('set', 'page', gaPage || '/');
      ga('set', 'title', gaTitle || 'DesertLandscaping');
      ga('send', 'pageview');
    } else {
      log("if !localhost ga would receive page: \"%s\" && title: \"%s\"", gaPage, gaTitle);
    }

    // log(App);

    if (App.data.pages && App.data.pages.length > 0) {
      log("pageData EXISTS");
      App.models.pageView.updatePage(App.data.pages);
    } else {
      log("pageData LOAD");
      // DESERTLAND.radio('dataPagesReady').subscribe([DESERTLAND.models.pageView.updatePage, DESERTLAND.models.pageView]);
      App.radio.unsubscribe('dataPagesReady', App.models.pageView.updatePage);
      App.radio.subscribe('dataPagesReady', App.models.pageView.updatePage);
    }
    //info(DESERTLAND.models.pageView);
    //DESERTLAND.models.pageView.set("page",App.currentPage);

    groupEnd("Router");

    this.updateShareVars(gaTitle, args);

  }

  public updateShareVars(gaTitle, args) {
    App.gaTitle = gaTitle;
    // App.shareArgs = {}; // we're not using shareArgs at this point
    // if (args) {
    //     //log('updateShareVars args: %o',args);
    //     App.shareArgs = args;//Object.assign({}, args);//ES6 shallow clone // or: JSON.parse(JSON.stringify(args));
    // }

    //this.updateShareFooter();
    //DESERTLAND.AddThis.update();
    AddThis.update();
    //    window.setTimeout(function() {
    //        AddThis.update();
    //    }, 1000);
  }

}

